var lpad = require('../string/lpad');
var toNumber = require('../lang/toNumber');

    /**
     * Add padding zeros if n.length < minLength.
     */
    function pad(n, minLength, char){
        n = toNumber(n);
        return lpad(''+ n, minLength, char || '0');
    }

    module.exports = pad;





//////////////////
// WEBPACK FOOTER
// ./~/mout/number/pad.js
// module id = 270
// module chunks = 0 1 2